"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TimezoneData = [
    { name: "American Samoa", offset: -660 }, { name: "International Date Line West", offset: -660 },
    { name: "Midway Island", offset: -660 },
    { name: "Hawaii", offset: -600 },
    { name: "Alaska", offset: -540 },
    { name: "Pacific Time (US & Canada)", offset: -480 }, { name: "Tijuana", offset: -480 },
    { name: "Arizona", offset: -420 }, { name: "Chihuahua", offset: -420 },
    { name: "Mazatlan", offset: -420 }, { name: "Mountain Time (US & Canada)", offset: -420 },
    { name: "Central America", offset: -360 },
    { name: "Central Time (US & Canada)", offset: -360 }, { name: "Guadalajara", offset: -360 },
    { name: "Mexico City", offset: -360 }, { name: "Monterrey", offset: -360 },
    { name: "Saskatchewan", offset: -360 },
    { name: "Bogota", offset: -300 }, { name: "Eastern Time (US & Canada)", offset: -300 },
    { name: "Indiana (East)", offset: -300 }, { name: "Lima", offset: -300 },
    { name: "Quito", offset: -300 },
    { name: "Atlantic Time (Canada)", offset: -240 }, { name: "Caracas", offset: -240 },
    { name: "Georgetown", offset: -240 }, { name: "La Paz", offset: -240 },
    { name: "Santiago", offset: -240 },
    { name: "Newfoundland", offset: -210 },
    { name: "Brasilia", offset: -180 }, { name: "Buenos Aires", offset: -180 },
    { name: "Greenland", offset: -180 }, { name: "Montevideo", offset: -180 },
    { name: "Mid-Atlantic", offset: -120 },
    { name: "Azores", offset: -60 }, { name: "Cape Verde Is.", offset: -60 },
    { name: "Casablanca", offset: 0 }, { name: "Dublin", offset: 0 },
    { name: "Edinburgh", offset: 0 }, { name: "Lisbon", offset: 0 }, { name: "London", offset: 0 },
    { name: "Monrovia", offset: 0 }, { name: "UTC", offset: 0 },
    { name: "Amsterdam", offset: 60 },
    { name: "Belgrade", offset: 60 }, { name: "Berlin", offset: 60 }, { name: "Bern", offset: 60 },
    { name: "Bratislava", offset: 60 }, { name: "Brussels", offset: 60 },
    { name: "Budapest", offset: 60 }, { name: "Copenhagen", offset: 60 },
    { name: "Ljubljana", offset: 60 }, { name: "Madrid", offset: 60 }, { name: "Paris", offset: 60 },
    { name: "Prague", offset: 60 }, { name: "Rome", offset: 60 }, { name: "Sarajevo", offset: 60 },
    { name: "Skopje", offset: 60 }, { name: "Stockholm", offset: 60 }, { name: "Vienna", offset: 60 },
    { name: "Warsaw", offset: 60 }, { name: "West Central Africa", offset: 60 },
    { name: "Zagreb", offset: 60 },
    { name: "Athens", offset: 120 }, { name: "Bucharest", offset: 120 },
    { name: "Cairo", offset: 120 }, { name: "Harare", offset: 120 },
    { name: "Helsinki", offset: 120 }, { name: "Istanbul", offset: 120 },
    { name: "Jerusalem", offset: 120 }, { name: "Kyiv", offset: 120 },
    { name: "Pretoria", offset: 120 }, { name: "Riga", offset: 120 }, { name: "Sofia", offset: 120 },
    { name: "Tallinn", offset: 120 }, { name: "Vilnius", offset: 120 },
    { name: "Baghdad", offset: 180 }, { name: "Kuwait", offset: 180 }, { name: "Minsk", offset: 180 },
    { name: "Moscow", offset: 180 }, { name: "Nairobi", offset: 180 },
    { name: "Riyadh", offset: 180 }, { name: "St. Petersburg", offset: 180 },
    { name: "Volgograd", offset: 180 },
    { name: "Tehran", offset: 210 },
    { name: "Abu Dhabi", offset: 240 }, { name: "Baku", offset: 240 },
    { name: "Muscat", offset: 240 }, { name: "Tbilisi", offset: 240 },
    { name: "Yerevan", offset: 240 },
    { name: "Kabul", offset: 270 },
    { name: "Ekaterinburg", offset: 300 }, { name: "Islamabad", offset: 300 },
    { name: "Karachi", offset: 300 }, { name: "Tashkent", offset: 300 },
    { name: "Chennai", offset: 330 }, { name: "Kolkata", offset: 330 },
    { name: "Mumbai", offset: 330 }, { name: "New Delhi", offset: 330 },
    { name: "Sri Jayawardenepura", offset: 330 },
    { name: "Kathmandu", offset: 345 },
    { name: "Almaty", offset: 360 }, { name: "Astana", offset: 360 }, { name: "Dhaka", offset: 360 },
    { name: "Urumqi", offset: 360 },
    { name: "Rangoon", offset: 390 },
    { name: "Bangkok", offset: 420 }, { name: "Hanoi", offset: 420 },
    { name: "Jakarta", offset: 420 }, { name: "Krasnoyarsk", offset: 420 },
    { name: "Novosibirsk", offset: 420 },
    { name: "Beijing", offset: 480 }, { name: "Chongqing", offset: 480 },
    { name: "Hong Kong", offset: 480 }, { name: "Irkutsk", offset: 480 },
    { name: "Kuala Lumpur", offset: 480 }, { name: "Perth", offset: 480 },
    { name: "Singapore", offset: 480 }, { name: "Taipei", offset: 480 },
    { name: "Ulaanbaatar", offset: 480 },
    { name: "Osaka", offset: 540 }, { name: "Sapporo", offset: 540 }, { name: "Seoul", offset: 540 },
    { name: "Tokyo", offset: 540 }, { name: "Yakutsk", offset: 540 },
    { name: "Adelaide", offset: 570 }, { name: "Darwin", offset: 570 },
    { name: "Brisbane", offset: 600 }, { name: "Canberra", offset: 600 },
    { name: "Guam", offset: 600 }, { name: "Hobart", offset: 600 },
    { name: "Melbourne", offset: 600 }, { name: "Port Moresby", offset: 600 },
    { name: "Sydney", offset: 600 }, { name: "Vladivostok", offset: 600 },
    { name: "Magadan", offset: 660 }, { name: "New Caledonia", offset: 660 },
    { name: "Solomon Is.", offset: 660 },
    { name: "Auckland", offset: 720 }, { name: "Fiji", offset: 720 },
    { name: "Kamchatka", offset: 720 }, { name: "Marshall Is.", offset: 720 },
    { name: "Wellington", offset: 720 },
    { name: "Chatham Is.", offset: 765 },
    { name: "Nuku\"alofa", offset: 780 }, { name: "Samoa", offset: 780 },
    { name: "Tokelau Is.", offset: 780 },
];
exports.TimezoneData = TimezoneData;
//# sourceMappingURL=timezones.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/skiliko-sdk/lib/data/timezones.js
// module id = 870
// module chunks = 3